import {
  Criteria,
  QuotaPayload,
} from '../../shared/interfaces/quota.interface';
import {
  ChildrenQuotaBuilder,
  GroupQuotaBuilder,
  QuotaBuilder,
  SimpleQuotaBuilder,
} from './quota-builder';
import { ChildrenQuotaMatch } from './quota-filter';
import { QuotaNumberCount } from './quota-number-count';

export class ChildrenGender {
  constructor(private readonly _quota: QuotaPayload) {}

  update(other: QuotaPayload): void {
    if (other.gender) {
      this._quota.gender = other.gender;
    }

    if (other.min && other.max) {
      this._quota.max = other.max;
      this._quota.min = other.min;
    }
  }
}

export class QuotaCriteria {
  constructor(private readonly _quota: QuotaPayload) {}

  merge(other: QuotaPayload): void {
    const criteria = other.criteria.pop();

    if (!criteria) {
      throw new Error('No criteria found!');
    }

    this._quota.criteria.push(criteria);
    const isChildren = new ChildrenQuotaMatch().filter(this._quota);

    if (isChildren) {
      new ChildrenGender(this._quota).update(other);
    }
  }
}

export class OriginalQuotas {
  constructor(private readonly _quota: QuotaPayload) {}

  public generate(counter: QuotaNumberCount): QuotaPayload[] {
    const quotas = new Map<string, QuotaPayload>();

    for (let criteria of this._quota.criteria) {
      const quota = this._builder(criteria, counter).build();
      const mapped = quotas.get(quota.text!);

      if (mapped) {
        new QuotaCriteria(mapped).merge(quota);
        continue;
      }

      quotas.set(quota.text!, quota);
    }

    return Array.from(quotas.values());
  }

  private _builder(
    criteria: Criteria,
    counter: QuotaNumberCount
  ): QuotaBuilder {
    const isChildrenQuota = new ChildrenQuotaMatch().filter({
      criteria: [criteria],
      required_count: 0,
    });

    if (isChildrenQuota) {
      return new ChildrenQuotaBuilder(counter, criteria);
    }

    if (criteria.condition_names && criteria.condition_names.length > 1) {
      return new GroupQuotaBuilder(counter, criteria);
    }

    return new SimpleQuotaBuilder(counter, criteria);
  }
}
